<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center border-b pb-3">
      <h2 class="text-xl font-semibold tracking-tight">Experience</h2>
    </div>

    <div class="flex flex-col gap-6 mt-2">
      <div v-for="(experience, index) in experiences" :key="index" class="relative pl-6 sm:pl-8">
        <!-- Vertical Line -->
        <span v-if="index !== experiences.length - 1" class="absolute left-[6.5px] top-4 h-[calc(100%+2rem)] w-px bg-border" aria-hidden="true"></span>
        
        <!-- Dot -->
        <span class="absolute left-[3px] top-[0.4rem] h-2 w-2 rounded-full bg-primary ring-4 ring-background" aria-hidden="true"></span>
        
        <div class="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-2">
          <h3 class="text-lg font-bold leading-tight">{{ experience.position }}</h3>
          <span class="text-sm font-mono text-muted-foreground">{{ experience.date }}</span>
        </div>
        
        <p class="text-sm font-medium mb-3">{{ experience.company }}</p>
        
        <p v-if="experience.description" class="text-sm text-muted-foreground leading-relaxed max-w-2xl text-justify">
          {{ experience.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExperienceSection",
  data() {
    return {
      experiences: [
        {
          position: "Intern - Web Developer",
          company: "Centralized Cloud Computing International, Inc.",
          date: "February 2026 - April 2026",
          description: " Address and resolve technical tickets for various web and mobile applications, fixing bugs of all types to ensure the systems run smoothly. Conduct comprehensive performance testing and debugging to identify system bottlenecks, ensuring seamless scalability for high-traffic platforms.  Collaborate with the support team to provide rapid technical solutions, directly improving user experience and system reliability across multiple client projects"
        },
        {
          position: "Intern - Frontend Developer",
          company: "Centralized Cloud Computing International, Inc.",
          date: "June - July 2025",
          description: "Developed a web-based OCR Receipt Scanner system, implementing user-friendly UI/UX designs, creating server API endpoints in the frontend connected to the backend, and implementing REST API functions for users with full-stack integration. Implemented database migrations for backend adjustments to database tables and columns, and adjusted the ERD to accommodate system changes."
        },
        {
          position: "Freelance - Web Builder",
          company: "",
          date: "February - March 2025",
          description: "Developed a full-featured apartment rental platform, focusing on enhanced user functionality and seamless end-to-end navigation. Implemented secure user authentication and real-time Firestore data integration, optimizing RESTful API endpoints for efficient property and inquiry management. Delivered a responsive, applied Accessibility/WCAG and dynamic UI/UX tailored for both tenants and landlords, resulting in increased user engagement and cross-device compatibility."
        },
        {
          position: "BS Information Technology",
          company: "Student",
          date: "2021 - 2026",
          description: ""
        }
      ]
    };
  }
};
</script>
